import { HttpCaseFlowInitiation } from "../Http";

export class visaCareLCAPAFDataAPI {

  public static createLCAPAFData(input: any) {
    var url = "caseflowinitiation/createChildLCA";
    var obj = JSON.stringify(input);
    if (input === "") {
      return { data: [] };
    }
    const resultMethod = HttpCaseFlowInitiation.axios().post(url, obj,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*"
        }
      })
      .then(res => {

        return res;
      }).catch((e: any) => {

        return e.response;
      });
    return resultMethod;
  }

  public static updateLCAPAFData(input: any) {

    var url = "caseflowinitiation/updateChildLCA";
     
    var obj = JSON.stringify(input);
  
    if (input === "") {
      return { data: [] };
    }
    const resultMethod = HttpCaseFlowInitiation.axios().put(url, obj,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*"
        }
      })
      .then(res => {

        return res;
      }).catch((e: any) => {

        return e.response;
      });
    return resultMethod;
  }

  public static getLCAPAFById(input: any) {

    var url = "caseflowinitiation/getChildLCADetailsById/" + input.input;

    if (input === "") {
      return { data: [] };
    }
 
    const resultMethod = HttpCaseFlowInitiation.axios()
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        }
      })
      .then(res => {
 
        return res;
      })
      .catch((e: any) => {
      
        return e.response;
      });

    return resultMethod;
  }


  public static getLCAPAFByChildCaseId(input: any) {

    var url = "caseflowinitiation/getChildCaseIdLCADetails/" + input.input;

    if (input === "") {
      return { data: [] };
    }
 
    const resultMethod = HttpCaseFlowInitiation.axios()
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        }
      })
      .then(res => {
 
        return res;
      })
      .catch((e: any) => {
      
        return e.response;
      });

    return resultMethod;
  }

  public static getLCAPAFByListCaseId(input: any) {

    var url = "caseflowinitiation/getChildLCADetailsList/" + input.input;

    if (input === "") {
      return { data: [] };
    }
 
    const resultMethod = HttpCaseFlowInitiation.axios()
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        }
      })
      .then(res => {
 
        return res;
      })
      .catch((e: any) => {
      
        return e.response;
      });

    return resultMethod;
  }

  public static getLCAPAFByCompanyId(input: any) {

    var url = "caseflowinitiation/getChildLCADetailsListFromCompanyId/" + input.input;

    if (input === "") {
      return { data: [] };
    }
 
    const resultMethod = HttpCaseFlowInitiation.axios()
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        }
      })
      .then(res => {
 
        return res;
      })
      .catch((e: any) => {
      
        return e.response;
      });

    return resultMethod;
  }

  public static getAllLCAPAFData() {

    var url = "caseflowinitiation/getAllChildLCADetails";

 
    const resultMethod = HttpCaseFlowInitiation.axios()
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        }
      })
      .then(res => {
 
        return res;
      })
      .catch((e: any) => {
      
        return e.response;
      });

    return resultMethod;
  }

}